<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-04 15:32:07
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:14:33
 * @name: 选择快递公司
 * @Description: 选择快递公司
 * @FilePath: \project\src\components\afterSale\dialog-choose-company.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="快递公司" width="400px" :visible.sync="show">
    <el-input
      size="mini"
      v-model="keyword"
      placeholder="请输入关键字"
    ></el-input>
    <div class="container">
      <div class="list">
        <div
          class="item"
          v-for="item of showList"
          :key="item.com"
          @click="com = item.com"
        >
          <div class="radio" :class="{ checked: com === item.com }">
            <div class="checked-dot"></div>
          </div>
          <font :title="item.company_name">{{ item.company_name }}</font>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button size="mini" @click="show = false">取消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { debounceation } from "@/utils/decorator";
export default {
  name: "dialogChooseCompany",
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      show: false,
      com: "",
      keyword: "",
    };
  },
  computed: {
    showList() {
      return this.list.filter((x) => x.company_name.indexOf(this.keyword) > -1);
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param com 快递公司代号
     */
    open(com) {
      this.com = com;
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    confirm() {
      this.$emit("chooseCompany", {
        com: this.com,
        company_name: this.list.find((x) => x.com === this.com).company_name,
      });
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 400px;
  margin: 5px 0;
  overflow-y: auto;
  .list {
    width: 100%;
    padding: 10px 0;
    @extend .et-flex-column-normal;
    .item {
      width: 100%;
      box-sizing: border-box;
      padding: 5px 20px;
      @extend .et-flex-start;
      @extend .et-clickElement;
      .radio {
        width: 12px;
        height: 12px;
        border: 1px solid $Vars-normal-color;
        border-radius: 12px;
        box-sizing: border-box;
        margin-right: 10px;
        @extend .et-flex-center;
        &.checked {
          background: $Vars-normal-color;
        }
        .checked-dot {
          width: 4px;
          height: 4px;
          border-radius: 4px;
          background: white;
        }
      }
      font {
        max-width: calc(100% - 20px);
        @extend .et-text-nowrap;
      }
    }
  }
}
.btn-group {
  margin-top: 20px;
  @extend .et-flex-center;
}
</style>